import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "g-recaptcha",
  "data-sitekey": "6LdWqTwqAAAAANM-eyjzX-pMXPu1MF_BVqLK_v3C"
}

import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormRecaptcha2',
  props: {
  field: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



const loadScript = async (src: string) => {
  try {
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  } catch (err) {
    console.error("Failed to load reCAPTCHA script:", err);
  }
};

onMounted(async () => {
  try {
    await loadScript("https://www.google.com/recaptcha/api.js");
  } catch (err) {
    console.error("Failed to load reCAPTCHA script:", err);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})